import { render, staticRenderFns } from "./SupplierOnboardingPhone.vue?vue&type=template&id=14bf5a7e&"
import script from "./SupplierOnboardingPhone.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports